import { render, staticRenderFns } from "./BookingEditor.vue?vue&type=template&id=689c2f5a&scoped=true&"
import script from "./BookingEditor.vue?vue&type=script&lang=js&"
export * from "./BookingEditor.vue?vue&type=script&lang=js&"
import style0 from "./BookingEditor.vue?vue&type=style&index=0&id=689c2f5a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "689c2f5a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VForm } from 'vuetify/lib/components/VForm';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAutocomplete,VDataTable,VDatePicker,VForm,VMenu,VSelect,VTextField})
